import React from 'react'
import { connect } from 'react-redux'
import { Container } from 'semantic-ui-react'

const PAGES_LIMIT_TO_DISPLAY_ALL_NUMBERS = 20

class Pagination extends React.Component {
  handleFilter = (data) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
    this.props.dispatch({ type: 'SHOP_ORDERS_FILTER_SAGA', payload: data })
  }

  renderPageChunks() {
    const { currentPage, totalPages } = this.props
    // chunk 1
    let nums = [1, 2, 3]
    // optional separator- only add in if there's a gap
    if (currentPage > 5) nums.push(undefined)
    // chunk 2- add in if the numbers aren't provided by chunk 3 (otherwise will be out of order)
    if (currentPage < totalPages) nums.push(currentPage - 1, currentPage, currentPage + 1)
    // optional separator- only add in if there's a gap
    if (totalPages > currentPage + 4) nums.push(undefined)
    // chunk 3
    nums.push(totalPages - 2, totalPages - 1, totalPages)

    const uniqueNums = nums.filter((value, index) => {
      return value == null ||
        (0 < value && value <= totalPages && nums.indexOf(value) === index)
    })

    return uniqueNums.map(n => this.item(n))
  }

  renderAllPages() {
    const { totalPages } = this.props
    let arr = []
    for(let n = 1; n <= totalPages; n++) { arr.push(n) }

    return arr.map(n => this.item(n))
  }

  item(number) {
    const { currentPage } = this.props
    return (
      <div
        style={{cursor: 'pointer'}}
        key={`pagination-item-${number}`}
        className={`item ${number === currentPage ? 'active' : ''}`}
        onClick={() => number != null && this.handleFilter({ current_page: number })}
      >
        {number == null ? '...' : number}
      </div>
    )
  }

  render() {
    const displayAllPageNumbers = this.props.totalPages <= PAGES_LIMIT_TO_DISPLAY_ALL_NUMBERS

    return (
      <Container>
        <div className="ui pagination menu" style={{marginBottom: '3rem'}}>
          { displayAllPageNumbers ? this.renderAllPages() : this.renderPageChunks() }
        </div>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  currentPage: state.shopOrders.current_page
})

export default connect(mapStateToProps)(Pagination)
